import {React, useState} from "react";
import Index from "./pages/Index";
import Home from "./pages/Home";
import Results from "./pages/Results";

export default function Frank() {
    const [activeTab, setActiveTab] = useState("index")

    return (
        <div>
            {/* Main content */}
            <main style = {{margin: "0px", padding: "0px"}}>
                {activeTab === "index" && <Index toHome = {() => setActiveTab("home")}/>}
                {activeTab === "home" && <Home toResults ={() => setActiveTab("results")}/>}
                {activeTab === "results" && <Results toHome ={() => setActiveTab("home")}/>}
            </main>
        </div>
    );
}
